/**
 * Home's suggestions: chosen by rules and labelled by title at once, then
 * relabelled when the server's written labels for the shown ones land.
 *
 * @module components/home/useHomeSuggestions
 */
import { useMemo } from "react";

import { useWrittenLabels } from "../../state/homeSuggestionLabels";
import { buildSuggestions, writtenLabeler, type Suggestion } from "./homeSuggestions.logic";

/** `organizationId` null asks for no labels. */
export function useHomeSuggestions(
  organizationId: string | null,
  input: Parameters<typeof buildSuggestions>[0],
): ReadonlyArray<Suggestion> {
  const { findings, comingUp, glance, now } = input;
  const titled = useMemo(() => buildSuggestions({ findings, comingUp, glance, now }), [findings, comingUp, glance, now]);
  const written = useWrittenLabels(organizationId, titled);
  return useMemo(() => {
    if (written.size === 0) return titled;
    const label = writtenLabeler(written);
    return titled.map((suggestion) => ({ ...suggestion, label: label(suggestion) }));
  }, [titled, written]);
}
